import { FeaturedWrapper } from "./FeaturedWrapper"
import { NewSubscribeButton } from "./cta"
import { NewPartnershipTierSelectorItemApplylistFragment } from "__generated__/NewPartnershipTierSelectorItemApplylistFragment"
import { NewPartnershipTierSelectorItemTierFragment } from "__generated__/NewPartnershipTierSelectorItemTierFragment"
import { BasePartnershipTierSelectorItem } from "../Base"

type NewPartnershipTierSelectorItemProps = {
    applylist: NewPartnershipTierSelectorItemApplylistFragment
    partnershipTier: NewPartnershipTierSelectorItemTierFragment
    referrer?: "jobs" | "talent"
}

export const NewPartnershipTierSelectorItem = (
    props: NewPartnershipTierSelectorItemProps
) => {
    return (
        <BasePartnershipTierSelectorItem
            {...props}
            wrapper={
                <FeaturedWrapper
                    isVisible={props.partnershipTier.isHighlightedTier}
                />
            }
            cta={<NewSubscribeButton {...props} />}
        />
    )
}
